export enum ETransactionType {
  FullPurchase,
  Subscription,
}
